// import axios from "axios"
import axios from "../../constants/axios"
import { navigate } from "gatsby-link"

import endpoints from "../../constants/endpoints"

export const VERIFY_PAY = async (page, setWholePageLoading) => {
  try {
    const formData = new FormData()
    formData.append("order_id", page.oid)
    formData.append("amount", page.amt)
    formData.append("refId", page.refId)
    formData.append("status", page.q)
    formData.append("paytype", page.type)
    const res = await axios.post(
      process.env.GATSBY_BASE_URL + endpoints.COMPANY_CHECKOUT_SUCCESS,
      formData
    )
    if (res.status === 200) {
      setWholePageLoading(false)
    }
  } catch (err) {
    navigate("/company/checkout?type=esewa&q=failed")
    setWholePageLoading(false)
  }
}

export const CHECKOUT_DATA = async (setData, setLoading) => {
  try {
    const res = await axios.get(
      process.env.GATSBY_BASE_URL + endpoints.COMPANY_CHECKOUT
    )
    setData(res.data)
    setLoading(false)
  } catch (err) {
    setLoading(false)
  }
}
